module.exports = __webpack_public_path__ + "public/img/ico-header-add.423fef4e.svg";